import { render, staticRenderFns } from "./MaterialsTreePage.vue?vue&type=template&id=50783c74&scoped=true&"
import script from "./MaterialsTreePage.vue?vue&type=script&lang=js&"
export * from "./MaterialsTreePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50783c74",
  null
  
)

export default component.exports